(function () {
  // run once DOM is ready (script is defer but keep safe)
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    var bar = document.getElementById('sticky-purchase-bar');
    if (!bar) return;

    var anchor = document.querySelector('[data-sticky-buy-buttons-anchor]');
    if (!anchor) return;

    // Main product form (first match is fine on product page)
    var form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    var mainSubmit =
      form.querySelector('button[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
    if (!mainSubmit) return;

    // --- helpers ---
    function cssEscapeSafe(s) {
      if (window.CSS && CSS.escape) return CSS.escape(s);
      return String(s).replace(/"/g, '\\"');
    }

    function applyBottomPadding() {
      var h = bar && bar.style.display !== 'none' ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.paddingBottom = h ? Math.ceil(h) + 'px' : '';
    }

    function showBar(show) {
        bar.classList.toggle('is-active', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('spb-active', show);
        if (show) {
            var h = bar.getBoundingClientRect().height || 0;
            document.documentElement.style.setProperty('--spb-safe-bottom', h + 'px');
        } else {
            document.documentElement.style.removeProperty('--spb-safe-bottom');
        }
        document.documentElement.style.paddingBottom = show ? '150px' : '';
    }

    // Price sync (Impulse uses [data-product-price])
    var livePrice = document.querySelector('[data-product-price]');
    var priceEl = document.getElementById('spb-price');
    if (livePrice && priceEl) {
      var updatePrice = function () {
        var t = (livePrice.textContent || '').trim();
        if (t) priceEl.textContent = t;
      };
      updatePrice();
      new MutationObserver(updatePrice).observe(livePrice, { childList: true, subtree: true, characterData: true });
    }

    // Marquee toggles (overflow only)
    function toggleMarqueeText(el) {
      if (!el) return;
      var parent = el.parentElement;
      if (!parent) return;
      var on = el.scrollWidth > parent.clientWidth + 2;
      parent.setAttribute('data-marquee', on ? 'on' : 'off');
    }
    function refreshMarquees() {
      toggleMarqueeText(document.getElementById('spb-title-text'));
      toggleMarqueeText(document.getElementById('spb-color-text'));
    }

    // Quantity sync (quantity input may be outside form and linked via form="id")
    var qtySticky = document.getElementById('spb-qty');
    var qtyMinus = document.getElementById('spb-qty-minus');
    var qtyPlus = document.getElementById('spb-qty-plus');

    function getQtyMain() {
      var formId = form.getAttribute('id');
      return (
        (formId
          ? document.querySelector('input[name="quantity"][form="' + cssEscapeSafe(formId) + '"]')
          : null) ||
        form.querySelector('input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]')
      );
    }

    var qtyMain = getQtyMain();

    function setQty(val) {
      var n = parseInt(val, 10);
      if (isNaN(n) || n < 1) n = 1;
      qtySticky.value = n;

      qtyMain = getQtyMain(); // resilient if DOM changes
      if (qtyMain) {
        qtyMain.value = n;
        qtyMain.dispatchEvent(new Event('input', { bubbles: true }));
        qtyMain.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (qtyMain && qtyMain.value) qtySticky.value = qtyMain.value;

    qtySticky.addEventListener('change', function () {
      setQty(qtySticky.value);
    });
    qtySticky.addEventListener('input', function () {
      setQty(qtySticky.value);
    });

    if (qtyMinus)
      qtyMinus.addEventListener('click', function () {
        setQty((parseInt(qtySticky.value || '1', 10) || 1) - 1);
      });
    if (qtyPlus)
      qtyPlus.addEventListener('click', function () {
        setQty((parseInt(qtySticky.value || '1', 10) || 1) + 1);
      });

    // main -> sticky qty
    if (qtyMain) {
      qtyMain.addEventListener('change', function () {
        if (qtyMain.value) qtySticky.value = qtyMain.value;
      });
      qtyMain.addEventListener('input', function () {
        if (qtyMain.value) qtySticky.value = qtyMain.value;
      });
    }

    // CTA: clone theme button (FULLY REUSED DESIGN), but type="button"
    var ctaSlot = document.getElementById('spb-cta-slot');
    var paymentButtons = mainSubmit.closest('.payment-buttons');
    var clonedWrap;

    if (paymentButtons) {
      clonedWrap = paymentButtons.cloneNode(true);
      var clonedAdd =
        clonedWrap.querySelector('button[name="add"]') || clonedWrap.querySelector('button[type="submit"]');
      if (clonedAdd) {
        clonedAdd.type = 'button';
        if (clonedAdd.id) clonedAdd.removeAttribute('id');
      }
      var spbPay = clonedWrap.querySelector('.shopify-payment-button');
      if (spbPay) spbPay.style.display = 'none';
      ctaSlot.appendChild(clonedWrap);
    } else {
      var b = mainSubmit.cloneNode(true);
      b.type = 'button';
      if (b.id) b.removeAttribute('id');
      clonedWrap = document.createElement('div');
      clonedWrap.className = 'payment-buttons';
      clonedWrap.appendChild(b);
      ctaSlot.appendChild(clonedWrap);
    }

    var stickyCTA = ctaSlot.querySelector('button[name="add"]') || ctaSlot.querySelector('button');

    function syncDisabled() {
      if (!stickyCTA) return;
      stickyCTA.disabled = !!mainSubmit.disabled;
      stickyCTA.setAttribute('aria-disabled', stickyCTA.disabled ? 'true' : 'false');
    }
    syncDisabled();
    new MutationObserver(syncDisabled).observe(mainSubmit, { attributes: true, attributeFilter: ['disabled', 'class'] });

    if (stickyCTA) {
      stickyCTA.addEventListener('click', function () {
        syncDisabled();
        if (stickyCTA.disabled) return;
        setQty(qtySticky.value);
        if (form.requestSubmit) form.requestSubmit(mainSubmit);
        else mainSubmit.click();
      });
    }

    // --- Thumbnail sync (main gallery -> sticky thumb) ---
    var spbThumbImg = document.getElementById('spb-thumb-img');

    function getActiveMainImageUrl() {
      var root = anchor.closest('.product-section') || document;

      var selectors = [
        '.product__photos .is-selected img',
        '.product__photos .slick-current img',
        '.product__photos [aria-hidden="false"] img',
        '.product-single__photos .is-selected img',
        '.product-single__photos .slick-current img',
        '.product-single__photos [aria-hidden="false"] img',
        '[data-product-images] .is-selected img',
        '[data-product-images] .slick-current img',
        '[data-product-images] [aria-hidden="false"] img'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var el = root.querySelector(selectors[i]);
        if (el && (el.currentSrc || el.src)) return el.currentSrc || el.src;
      }

      var fallback =
        root.querySelector('.product__photos img') ||
        root.querySelector('.product-single__photos img') ||
        root.querySelector('[data-product-images] img');

      return fallback ? (fallback.currentSrc || fallback.src) : null;
    }

    function updateStickyThumbFromMain() {
      if (!spbThumbImg) return;
      var url = getActiveMainImageUrl();
      if (!url) return;
      if ((spbThumbImg.currentSrc || spbThumbImg.src) !== url) spbThumbImg.src = url;
    }

    (function observeMainGalleryForThumb() {
      var root = anchor.closest('.product-section') || document;
      var gallery =
        root.querySelector('[data-product-images]') ||
        root.querySelector('.product__photos') ||
        root.querySelector('.product-single__photos');

      if (!gallery || !('MutationObserver' in window)) return;

      var mo = new MutationObserver(function () {
        updateStickyThumbFromMain();
      });

      mo.observe(gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'class', 'aria-hidden']
      });
    })();

    // Color dropdown (swatch reuse)
    var colorWrap = document.getElementById('spb-color-wrap');
    var colorMenu = document.getElementById('spb-color-menu');
    var colorSwatch = document.getElementById('spb-color-swatch');
    var colorDetails = document.getElementById('spb-color-dd');

    var swatchInputs = document.querySelectorAll('input.variant__input--color-swatch[data-variant-input]');
    if (!swatchInputs || swatchInputs.length === 0) swatchInputs = document.querySelectorAll('input.variant__input--color-swatch');

    function getLabelForInput(input) {
      if (!input || !input.id) return null;
      return document.querySelector('label[for="' + cssEscapeSafe(input.id) + '"]');
    }

    function setColorUIFromChecked() {
      if (!swatchInputs || swatchInputs.length === 0) return;

      var checked = null;
      swatchInputs.forEach(function (i) { if (i.checked) checked = i; });
      if (!checked) checked = swatchInputs[0];

      var lb = getLabelForInput(checked);
      var name = (checked.getAttribute('data-color-name') || checked.value || (lb ? lb.textContent : '') || '').trim();

      var ct = document.getElementById('spb-color-text');
      if (ct) ct.textContent = name || 'カラー';

      if (colorSwatch && lb) {
        colorSwatch.style.backgroundColor = lb.style.backgroundColor || '';
        colorSwatch.style.backgroundImage = lb.style.backgroundImage || '';
      }

      setTimeout(function () {
        refreshMarquees();
      }, 0);
    }

    function buildColorMenu() {
      if (!swatchInputs || swatchInputs.length === 0) return false;

      colorWrap.style.display = '';
      colorMenu.innerHTML = '';

      swatchInputs.forEach(function (input) {
        var lb = getLabelForInput(input);
        if (!lb) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'spb-dd__item';
        btn.setAttribute('aria-selected', input.checked ? 'true' : 'false');

        var sw = document.createElement('span');
        sw.className = 'spb-dd__itemSwatch';
        sw.style.backgroundColor = lb.style.backgroundColor || '';
        sw.style.backgroundImage = lb.style.backgroundImage || '';

        var tx = document.createElement('span');
        tx.className = 'spb-dd__itemText';
        tx.textContent = (input.getAttribute('data-color-name') || input.value || lb.textContent || '').trim();

        btn.appendChild(sw);
        btn.appendChild(tx);

        btn.addEventListener('click', function () {
          input.click();
          buildColorMenu();
          setColorUIFromChecked();
          colorDetails.removeAttribute('open');

          setTimeout(updateStickyThumbFromMain, 60);
        });

        colorMenu.appendChild(btn);
      });

      setColorUIFromChecked();
      return true;
    }

    if (swatchInputs && swatchInputs.length > 0) {
      swatchInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          buildColorMenu();
          setColorUIFromChecked();
          syncDisabled();
          setTimeout(updateStickyThumbFromMain, 60);
        });
      });
      buildColorMenu();
    }

    // Size dropdown (reuse underlying select)
    var sizeWrap = document.getElementById('spb-size-wrap');
    var sizeSelectSticky = document.getElementById('spb-size-select');

    function findSizeSelectOnPage() {
      var candidates = Array.prototype.slice.call(document.querySelectorAll('fieldset.variant-input-wrap, .variant-input-wrap'));
      for (var i = 0; i < candidates.length; i++) {
        var fs = candidates[i];
        var n = (fs.getAttribute('name') || '').trim();
        var h = (fs.getAttribute('data-handle') || '').trim();
        if ((n && n.indexOf('サイズ') !== -1) || (h && h.indexOf('サイズ') !== -1)) {
          var sel = fs.querySelector('select');
          if (sel) return sel;
        }
      }
      var all = Array.prototype.slice.call(document.querySelectorAll('select'));
      for (var j = 0; j < all.length; j++) {
        var s = all[j];
        if (s.closest('.product-single__meta') && !s.closest('.shopify-payment-button')) {
          if (s.options && s.options.length >= 2) return s;
        }
      }
      return null;
    }

    var sizeSelectMain = findSizeSelectOnPage();

    function rebuildSizeSelect() {
      if (!sizeSelectMain || !sizeSelectSticky) return false;

      sizeWrap.style.display = '';
      sizeSelectSticky.innerHTML = '';

      for (var i = 0; i < sizeSelectMain.options.length; i++) {
        var o = sizeSelectMain.options[i];
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = o.textContent;
        opt.disabled = o.disabled;
        opt.selected = o.selected;
        sizeSelectSticky.appendChild(opt);
      }
      return true;
    }

    if (sizeSelectMain && rebuildSizeSelect()) {
      sizeSelectSticky.addEventListener('change', function () {
        sizeSelectMain.value = sizeSelectSticky.value;
        sizeSelectMain.dispatchEvent(new Event('input', { bubbles: true }));
        sizeSelectMain.dispatchEvent(new Event('change', { bubbles: true }));
        syncDisabled();
      });

      sizeSelectMain.addEventListener('change', function () {
        rebuildSizeSelect();
        syncDisabled();
      });

      new MutationObserver(function () {
        rebuildSizeSelect();
        syncDisabled();
      }).observe(sizeSelectMain, { childList: true, subtree: true, attributes: true });
    }

    // --- SHOW/HIDE RULE:
    // Show ONLY when buy-buttons anchor has scrolled ABOVE the top of viewport.
    function getMainSubmitHeight() {
      try {
        var rect = mainSubmit.getBoundingClientRect();
        return Math.max(0, rect.height || 0);
      } catch (e) {
        return 0;
      }
    }

    function updateVisibility() {
      var r = anchor.getBoundingClientRect();
      var offset = getMainSubmitHeight() + 12;
      var aboveTopEnough = r.bottom < 0 - offset;
      showBar(aboveTopEnough);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () {
        updateVisibility();
      }, { threshold: [0, 0.01, 1] });
      io.observe(anchor);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', function () {
      applyBottomPadding();
      refreshMarquees();
    });

    // initial
    setTimeout(function () {
      updateVisibility();
      refreshMarquees();
      updateStickyThumbFromMain();
      applyBottomPadding();
    }, 60);

    // Close color dropdown if user taps outside
    document.addEventListener('click', function (e) {
      if (!colorDetails || !colorDetails.hasAttribute('open')) return;
      if (!colorDetails.contains(e.target)) colorDetails.removeAttribute('open');
    });
  });
})();